/**
 * API 에러 처리 유틸리티
 *
 * #380 Stage 2 — 전 영역 i18n 적용. ko/es/en 3언어 동적 fallback.
 * (Stage 1: es-MX 단일 fallback / Stage 2: AppContext locale 주입)
 *
 * 박제 D 단일 출처: error-messages.ts.
 * client.ts handleResponse / handleResponseWithMeta 도 동일 표 참조.
 */
import { ApiClientError } from './client';
import {
  getStatusMessage,
  setApiErrorLanguage,
  getApiErrorLanguage,
} from './error-messages';

// re-export so existing callers (AppContext) can import from this module
export { setApiErrorLanguage, getApiErrorLanguage };

/**
 * HTTP 상태 코드별 에러 메시지 생성 (현재 언어 기준).
 */
export function getErrorMessage(err: unknown, defaultMessage: string): string {
  if (err instanceof ApiClientError) {
    const message = getStatusMessage(err.status);
    if (message) return message;
    return err.message || defaultMessage;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return defaultMessage;
}
